import {Fragment, useState, useEffect, useCallback} from 'react';
import Question from "../Question/Question";
import Answer from "../Answer/Answer";
import Button from "../Button/Button";
import {KeySolver} from "../../KeySolver";
import { useParams } from 'react-router';
import Counter from "./Counter";
import { useGlobalState } from "../../GlobalStateProvider";

const Survey: (props: any) => JSX.Element = (props: any) => {

    const [originalQuestions, setOriginalQuestions] = useState<any[]>();
    const [questions, setQuestions] = useState<any[]>();
    const [showNext, setShowNext] = useState<boolean>(false);

    const {state, setState} = useGlobalState();

    const active: number = state.active;
    const answers: any = state.answers;

    const setActive = (val: number) => {
        setState({...state, active: val})
    }

    const { id } = useParams();

    const apiUrl = process.env.REACT_APP_API_URL;

    const getSurvey = useCallback(() => {
        fetch(`${apiUrl}/survey/api/index/${id}`, {method: 'GET', redirect: 'follow'})
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if(result && result.questions) {
                    setOriginalQuestions(result.questions);
                    setQuestions(result.questions);
                }

            })
            .catch(error => console.log('error', error));
    }, [apiUrl, id]);

    useEffect(() => {
        getSurvey()
    }, [getSurvey]);

    useEffect(() => {
        if (originalQuestions) {
            const updatedQuestions = originalQuestions.filter(item => {
                if (item.question.dependencies && item.question.dependencies.length > 0) {
                    return item.question.dependencies.every((dependency: any) => answers.includes(dependency));
                }
                return true;
            });
            setQuestions(updatedQuestions);
        }
    }, [state, answers, originalQuestions]);

    useEffect(() => {
        setShowNext(false);
        if(questions && questions.length > 0) {
            const question = questions[active];
            if(question && state.answers && state.answers.length > 0 && question.children && question.children.length > 0) {
                const children = question.children;
                for (let i in children) {
                    if(state.answers.includes(children[i].properties.identifier)) {
                        setShowNext(true);
                    }
                }
            }
        }
    }, [questions, active, state]);

    return (
        <Fragment>

            <input type="hidden" name={`survey[nodeIdentifier]`} defaultValue={id} />

            <Counter questions={questions} active={active} setActive={(p: number) => setActive(p)} />

            {questions && questions.map((item: any, i: number) =>
                <Fragment key={KeySolver()} >
                    <QuestionItem item={item} i={i} active={active} questions={questions} originalQuestions={originalQuestions} setQuestions={(p: any) => setQuestions(p)} answers={answers} state={state} />
                </Fragment>
            )}

            <div className={`flex flex-row justify-center gap-5`}>

                {questions && active !== 0 && active !== questions.length &&
                    <Button onClick={() => setActive(active - 1)} >
                        Zurück
                    </Button>
                }

                {questions && active !== questions.length &&
                    <Button onClick={() => setActive(active + 1)} attributes={{disabled: (!showNext)}} className={`${showNext ? '' : 'opacity-5'}`} >
                        {active === (questions.length - 1) ? 'Fragebogen abschließen' : 'Weiter'}
                    </Button>
                }

                {questions && active === questions.length &&
                    <Button type="submit">
                        Fragebogen übermitteln
                    </Button>
                }

            </div>

        </Fragment>
    );
}

export default Survey;

const QuestionItem: (props: any) => JSX.Element = (props: any) => {

    const {item, i, active} = props;

    const childrenContainsImages = (items: any): boolean => {
        for(let i in items) {
            const item = items[i];
            if(item && item.properties && item.properties.image) {
                return true;
            }
        }
        return false;
    }

    return (
        <Fragment>
            <section id={`q${i}`} className={`${active === i ? '' : 'hidden'}`} >
                <Question name={`survey[questions][${i}][question]`}>
                    {item.question.text}
                    <div className="text-[16px] font-normal">{item.question.description}</div>
                    <input type="hidden" name={`survey[questions][${i}][question]`} defaultValue={item.question.identifier} />
                </Question>
                {item.children && item.children.length > 0 &&
                    <Fragment>
                        <div className={`${item.children.length > 5 ? 'lg:grid lg:grid-cols-2' : (childrenContainsImages(item.children) ? 'grid grid-cols-2 lg:grid-cols-4' : '')}`}>
                            {item.children.map((childItem: any, k: number) =>
                                <Fragment key={KeySolver()} >
                                    <Answer questionKey={i} name={`survey[questions][${i}][answer]${item.question.isMultiple ? `[${k}]` : ''}`} isRadio={!item.question.isMultiple} isString={childItem.properties.isString} defaultValue={childItem.properties.identifier} childItem={childItem} value={childItem.properties && childItem.properties.value} image={childItem.properties && childItem.properties.image} categories={childItem.properties && childItem.properties.categories} subItems={childItem.children} i={i} k={k} >{childItem.properties.text}</Answer>
                                </Fragment>
                            )}
                        </div>
                    </Fragment>
                }
            </section>
        </Fragment>
    );
}
